<template>
  <div class="ideas">
    <div class="container">
      <h1 class="title">{{ $t('ideas.title') }}</h1>
      <div class="content">
        <Filters @openFilters="filtersOpened = $event" />
        <div
          class="ideas__list"
          :class="[
            filtersOpened && ($mq === 'sm' || $mq === 'md') ? 'hidden' : '',
          ]"
        >
          <Item v-for="(idea, index) of list" :key="index" :idea="idea" />
          <infinite-loading
            ref="infload"
            v-if="
              canBeLoaded && !(filtersOpened && ($mq === 'sm' || $mq === 'md'))
            "
            @infinite="loadMore"
            spinner="spiral"
            class="spinner"
          >
          </infinite-loading>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import Item from './Item'
import Filters from './Filters'

export default {
  data() {
    return {
      filtersOpened: false,
    }
  },
  mounted() {
    this.$store.commit('ideas/setCanBeLoaded', true)
    this.unsubscribe = this.$store.subscribeAction({
      after: (action) => {
        if (action.type === 'user/logout') {
          this.loadIdeasList()
        }
      },
    })
  },
  beforeDestroy() {
    this.unsubscribe()
  },
  methods: {
    loadMore($state) {
      this.$store
        .dispatch('ideas/loadIdeasList')
        .then(() => {
          $state.loaded()
          if (!this.canBeLoaded) $state.complete()
        })
        .catch((err) => {
          console.log('loadMore', err)
          $state.error(err)
        })
    },
    loadIdeasList() {
      this.$store.commit('ideas/setPages', 0)
      this.$store.dispatch('ideas/loadIdeasList')
    },
  },
  computed: {
    list() {
      return this.$store.getters['ideas/getIdeasList']
    },
    canBeLoaded() {
      return this.$store.state.ideas.canBeLoaded
    },
  },
  components: {
    InfiniteLoading,
    Item,
    Filters,
  },
}
</script>

<style lang="scss">
.ideas {
  .title {
    padding: 39px 0 24px 1px;
    margin: 0;
    font-size: 32px;
  }
  .content {
    display: flex;
    justify-content: space-between;
    .ideas__list {
      flex: 5 5 1030px;
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
      gap: 32px;
      &.hidden {
        display: none;
      }
      .spinner {
        grid-column-start: 1;
        grid-column-end: -1;
      }
    }
  }

  @media (max-width: 767px) {
    .content {
      flex-direction: column;
      justify-content: baseline;
    }
  }
}
</style>
